import { connect, mapProps, mapReadPretty } from '@formily/react'
import { NumberPicker as InputNumber } from '@alicloudfe/components'
import { PreviewText } from '../preview-text'
import { mapSize, mapStatus } from '../__builtins__'
export const NumberPicker = connect(
  InputNumber,
  mapProps(mapSize, mapStatus),
  mapReadPretty(PreviewText.NumberPicker)
)

export default NumberPicker
